module.exports = __webpack_public_path__ + "static/media/5W-50-logo-white-min.5cfa24f2.webp";